import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { SiblingBrand } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: SiblingBrand) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: SiblingBrand;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors } = useForm<SiblingBrand>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    defaultValues: props.data,
  });

  const renderBaseUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Base Url</label>
          <Controller
            key={`baseUrl-controller`}
            control={control}
            rules={{
              required: 'Base Url is required',
              validate: {
                validUrl: (value) => validator.isURL(value) || 'Invalid URL',
              },
            }}
            name={`baseUrl`}
            render={({ onChange, value, name }) => (
              <input
                key={`baseUrl`}
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Base Url"
                name={name}
                value={value}
                onChange={onChange}
                id={`baseUrl`}
              />
            )}
          />
          <ErrorMessage>{errors.baseUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderBrandName = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Brand Name</label>
          <Controller
            key={`brandName-controller`}
            control={control}
            rules={{
              required: 'Brand Name is required',
            }}
            name={`brandName`}
            render={({ onChange, value, name }) => (
              <input
                key={`brandName`}
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Brand Name"
                name={name}
                value={value}
                onChange={onChange}
                id={`brandName`}
              />
            )}
          />
          <ErrorMessage>{errors.brandName?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit(props.onSubmit)}
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            {props.data ? 'Update' : 'Add'}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="p-4">
      <h4 className="mb-3 font-weight-semibold">
        {props.data ? 'Update' : 'Add'} Sibling Brand
      </h4>
      <div className="row gutter-10">
        {renderBrandName()}
        {renderBaseUrl()}
        <ErrorMessage>{props.error}</ErrorMessage>
        {renderButton()}
      </div>
    </div>
  );
};

export default UpdateForm;
